import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Scrolly from "./Scrolly";
import "../style/TopScrolly.scss";

const TopScrolly = (props) => {
  const { steps, width, height } = props;

  const [progress, setProgress] = useState({
    overallPct: 0,
    currentStep: 0,
    currentStepPct: 0,
  });

  // useEffect(() => {
  //   console.log("currentStep: " + progress.currentStep);
  // }, [progress]);

  useEffect(() => {
    console.log(width);
  }, [width]);

  // <D3ScrollChart {...progress} />
  return (
    <Scrolly
      onProgressHandler={setProgress}
      steps={steps}
      type={"top-scrolly"}
      width={width}
      height={height}
    >
      <div className="top-scrollly-box">
        {width >= height ? (
          <>
            <div
              className={
                progress.currentStep === 0
                  ? "top-scrolly-cover full-cover"
                  : "top-scrolly-cover less-cover"
              }
            ></div>

            <div
              className={
                progress.currentStep === 0
                  ? "sticky-img small-screen"
                  : progress.currentStep === 1
                  ? "sticky-img full-screen"
                  : "sticky-img scaled-screen"
              }
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/top_scrolly/top_scrolly.jpg)`,
                backgroundSize: "cover",
              }}
            ></div>
          </>
        ) : (
          <>
            <div
              className={
                progress.currentStep === 0
                  ? "top-scrolly-cover-mobile full-cover"
                  : "top-scrolly-cover-mobile less-cover"
              }
            ></div>

            <div
              className={
                progress.currentStep === 0
                  ? "sticky-img-mobile small-screen-mobile"
                  : progress.currentStep === 1
                  ? "sticky-img-mobile full-screen"
                  : "sticky-img-mobile scaled-screen-mobile"
              }
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/top_scrolly/top_scrolly_m.jpg)`,
                backgroundSize: "cover",
              }}
            ></div>
          </>
        )}
      </div>
    </Scrolly>
  );
};

export default TopScrolly;

//   <div
//     className={
//       progress.currentStep === 0
//         ? width > height
//           ? "top-scrolly-cover full-cover"
//           : "top-scrolly-cover-mobile full-cover"
//         : width > height
//         ? "top-scrolly-cover less-cover"
//         : "top-scrolly-cover-mobile less-cover"
//     }
//   ></div>
//   <div
//     className={
//       progress.currentStep === 0
//         ? width > height
//           ? "sticky-img small-screen"
//           : "sticky-img small-screen-mobile"
//         : progress.currentStep === 1
//         ? "sticky-img full-screen"
//         : width > height
//         ? "sticky-img scaled-screen"
//         : "sticky-img scaled-screen-mobile"
//     }
//     style={{
//       backgroundImage:
//         width > height
//           ? `url(${process.env.PUBLIC_URL}/images/top_scrolly/top_scrolly.jpg)`
//           : `url(${process.env.PUBLIC_URL}/images/top_scrolly/top_scrolly_m.jpg)`,
//       backgroundSize: "cover",
//     }}
//   ></div>
// </div>
